import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        const title = this.props.disableTitleSuffix
            ? this.props.pageTitle
            : `${this.props.pageTitle} || Product Leader`;

        return(
            <React.Fragment>
                <Helmet>
                    <title>{title}</title>
                    <meta name="description" content="Matteo Giuzzi - Product Leader" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
